import React, { useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebaseConfig.js';

// Importación de componentes con extensiones de archivo explícitas
import AuthComponent from './components/Auth/AuthComponent.js';
import Sidebar from './components/Layout/Sidebar.js';
import AddStudent from './components/Students/AddStudent.js';
import StudentList from './components/Students/StudentList.js';
import AddAchievement from './components/Achievements/AddAchievement.js';
import GradeSheet from './components/Grades/GradeSheet.js';
import BulletinGenerator from './components/Bulletins/BulletinGenerator.js';
import Promotions from './components/Promotions/Promotions.js';

// Componente principal que organiza la aplicación.
export default function App() {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [activeView, setActiveView] = useState('students'); // Vista inicial

    // --- NUEVO: Estado Global del Año Escolar ---
    const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

    useEffect(() => {
        // onAuthStateChanged es un listener que se activa cuando el estado de autenticación cambia.
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            setUser(currentUser);
            setLoading(false);
        });
        // Limpia el listener cuando el componente se desmonta.
        return () => unsubscribe();
    }, []);

    // Muestra un mensaje de carga mientras se verifica la autenticación.
    if (loading) {
        return <div className="min-h-screen flex items-center justify-center text-xl">Cargando...</div>;
    }

    // Si no hay usuario, muestra el componente de autenticación.
    if (!user) {
        return <AuthComponent />;
    }

    // Función para renderizar el componente de la vista activa.
    const renderView = () => {
        switch (activeView) {
            case 'students':
                return (
                    <div>
                        <AddStudent user={user} currentYear={currentYear} />
                        <StudentList user={user} currentYear={currentYear} />
                    </div>
                );
            case 'achievements':
                return <AddAchievement user={user} currentYear={currentYear} />;
            case 'grades':
                return <GradeSheet user={user} currentYear={currentYear} />;
            case 'bulletins':
                return <BulletinGenerator user={user} currentYear={currentYear} />;
            case 'promotions':
                return <Promotions user={user} currentYear={currentYear} />;
            default:
                // Por defecto, muestra la vista de estudiantes.
                return (
                    <div>
                        <AddStudent user={user} currentYear={currentYear} />
                        <StudentList user={user} currentYear={currentYear} />
                    </div>
                );
        }
    };

    // Si hay un usuario, muestra la interfaz principal de la aplicación.
    return (
        <div className="min-h-screen font-sans text-slate-800">
            <div className="md:flex">
                <Sidebar
                    activeView={activeView}
                    setActiveView={setActiveView}
                    currentYear={currentYear}
                    setCurrentYear={setCurrentYear}
                />
                <main className="flex-1 p-4 sm:p-6 lg:p-8">
                    {renderView()}
                </main>
            </div>
        </div>
    );
}